/**
 * @fileoverview Speed dial item data source and type definitions.
 */

import { SpeedDialItemSchema, type SpeedDialItem } from '@schema/index';
import { createBaseDataSource } from './base-data-source';
import { getCache } from './cache-registry';
import { createAuditFields, createBooleanField, createIdField, createJsonField, createNumberField, createStringField, FIELD_TYPE_WIDTHS, FIELD_WIDTHS } from './field-factories';

export type { SpeedDialItem };

export const speedDialItemDataSource = createBaseDataSource<SpeedDialItem>({
  endpoint: 'speed_dial_item',
  searchField: 'label',
  schema: SpeedDialItemSchema,
  fields: [
    createIdField(),
    createStringField('label', 'Label', FIELD_TYPE_WIDTHS.NAME),
    createStringField('icon_name', 'Icon', FIELD_WIDTHS.MEDIUM),
    createStringField('route_path', 'Route Path', FIELD_WIDTHS.LARGE),
    createNumberField('display_order', 'Display Order', FIELD_WIDTHS.SMALL),
    createBooleanField('is_enabled', 'Enabled', FIELD_WIDTHS.SMALL),
    createJsonField('metadata', 'Metadata', FIELD_WIDTHS.XLARGE),
    ...createAuditFields(),
  ],
});

export const speedDialItemCache = getCache('speed_dial_item');

